import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import mobileContainerImg from '../../Assets/mobileContainerImg.jpg';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import carousel1 from '../../Assets/carousel1.jpg';
import carousel2 from '../../Assets/carousel2.jpg';
import carousel3 from '../../Assets/carousel3.jpg';
import carousel4 from '../../Assets/carousel4.jpg';
import carousel5 from '../../Assets/carousel5.jpg';
import carousel6 from '../../Assets/carousel6.jpg';
import carousel7 from '../../Assets/carousel7.jpg';

const MobileCarousel = () => {
  //   const indicatorStyles = {
  //     background: '#fff',
  //     width: 12,
  //     height: 12,
  //     borderRadius: '50%',
  //     display: 'inline-block',
  //     margin: '0 8px'
  //   };
  return (
    <div className="mobileCarousel">
      <div className="mobileCarousel__fullWidthVid">
        <video playsInline autoPlay muted width="320" height="240">
          <source
            src="https://courageous-cdn-media-bucket.s3.amazonaws.com/intelWonderful/container.mp4"
            type="video/mp4"
          />
        </video>
        <p>
          N50 consulted with some 50 non-government aid organizations to make sure that the PCC
          contained the digital solutions Ukrainian refugees needed most.
        </p>
      </div>
      <div className="mobileCarousel__carouselCont">
        <div className="mobileCarousel__carouselCont__imgCont">
          <img src={mobileContainerImg} alt="shipping container" />
        </div>
        <div className="mobileCarousel__carouselCont__carousel">
          <Carousel showStatus={false} showThumbs={false} showArrows={false}>
            <div>
              <img src={carousel1} alt="plug graphic" />
              {/* <p className="legend">Legend 1</p> */}
            </div>
            <div>
              <img src={carousel2} alt="plug graphic" />
              {/* <p className="legend">Legend 1</p> */}
            </div>
            <div>
              <img src={carousel3} alt="plug graphic" />
              {/* <p className="legend">Legend 1</p> */}
            </div>
            <div>
              <img src={carousel4} alt="plug graphic" />
              {/* <p className="legend">Legend 1</p> */}
            </div>
            <div>
              <img src={carousel5} alt="plug graphic" />
              {/* <p className="legend">Legend 1</p> */}
            </div>
            <div>
              <img src={carousel6} alt="plug graphic" />
              {/* <p className="legend">Legend 1</p> */}
            </div>
            <div>
              <img src={carousel7} alt="plug graphic" />
              {/* <p className="legend">Legend 1</p> */}
            </div>
          </Carousel>
        </div>
        <p>
          Caption: N50 consulted with some 50 non-government aid organizations to make sure that the
          PCC contained the digital solutions Ukrainian refugees needed most.
        </p>
      </div>
    </div>
  );
};

export default MobileCarousel;
